import styled from 'styled-components';

const Title = styled.h3`
  margin: 0;
  font-weight: bold;
  font-size: var(--font-size-s);
`;

export default Title;
